const IN_APP_BROWSER_PATTERN = /NAVER|KAKAOTALK|Instagram|FBAN|FBAV|Line\/|MicroMessenger/i;

export const detectInAppBrowser = () => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  if (IN_APP_BROWSER_PATTERN.test(ua)) return true;

  return /iPhone|iPad|iPod/.test(ua) && !/Safari\//.test(ua) && !/CriOS\//.test(ua);
};

export const isIOSDevice = () => (
  typeof navigator !== 'undefined' && /iPhone|iPad|iPod/.test(navigator.userAgent || '')
);

export const shouldUseRedirectForGoogleAuth = () => detectInAppBrowser();

export const shouldFallbackToRedirect = error => {
  const redirectableCodes = new Set([
    'auth/cancelled-popup-request',
    'auth/operation-not-supported-in-this-environment',
    'auth/popup-blocked',
    'auth/unauthorized-domain',
    'auth/web-storage-unsupported',
  ]);

  if (redirectableCodes.has(error?.code)) return true;
  return detectInAppBrowser() && error?.code === 'auth/popup-closed-by-user';
};
